import { createFileRoute } from '@tanstack/react-router'
import { General } from './-steps/general'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_documents/_forms/bedarfsermittlung/$form/')({
  component: General,
})
